export default "__VITE_PUBLIC_ASSET__cf2413a6__"